export default "__VITE_ASSET__81ce8b9b__"